import gql from 'graphql-tag';

/** 订阅计划 */
export const SUBSCRIPTIONPLAN_FRAGMENT = gql`
  fragment SubscriptionPlan on SubscriptionPlan {
    id
    createdAt
    updatedAt
    name
    channelId
    payUpFront
    fixedStartDate
    autoRenew
    cutOffDays
    subscriptionInterval {
      unit
      frequency
    }
    periodAndDiscount {
      expireNumberOfPeriod
      discountType
      discountAmount
      recommend
    }
  }
`;
